import { render, staticRenderFns } from "./TptPersonalInfo.vue?vue&type=template&id=1418e794&scoped=true"
import script from "./TptPersonalInfo.vue?vue&type=script&lang=js"
export * from "./TptPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./TptPersonalInfo.vue?vue&type=style&index=0&id=1418e794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418e794",
  null
  
)

export default component.exports